import React,{useState} from 'react'
import SidebarOfAdash from '../subComponent/SidebarOfAdash'
import HeaderofAdash from '../subComponent/HeaderofAdash'
import { Row,Col } from 'react-bootstrap'
import Dropdown2 from '../../subComponents/CustomSubComponents/Dropdown2'
import { optionssession } from '../../Helper'
import Purplebutton from './subComponent/Purplebutton'
import { validationDrp } from '../../subComponents/CustomSubComponents/ValidationComp'

const PreOSetupMonthlyStuTeaComp = () => {
    const [bordersession, setbordersession] = useState("")
    const [labelsession, setlabelsession] = useState("")
    const [drpsession, setdrpsession] = useState("")
    const [perioderr,setperioderr] = useState("")
    const [periodlabel,setperiodlabel] = useState("")
    const [period,setperiod] = useState("")
    const drpfuncsession = (myval, myid) => {
        setdrpsession(myval)
    }
    const drpfuncperiod = (myval, myid) => {
        setperiod(myval)
    }
    const handleSave=()=>{
        validationDrp(drpsession,setlabelsession,setbordersession,"Session Required")
        validationDrp(period,setperiodlabel,setperioderr,"Period Required")
    }
  return (
    <>
    <div className="d-flex">

        <SidebarOfAdash />
        <div className="contentpartwidthwrapper">
            <HeaderofAdash head="Setup Monthly Student Subject & Teacher" />
            <div className="contentofadmindash contentflexvalue">
                <div className="w690 m-auto">
                    <Row style={{marginTop:"40vh"}}>
                    <Col lg={6} className="pr7">
                        <div className="basicinput">
                            <p>Session</p>
                            <div className="inputgap ">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={bordersession === "err" ? "err" : ""} func={drpfuncsession} myplaceholder="Select" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                <label>{labelsession}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={6} className="pr7">
                        <div className="basicinput">
                            <p>Periods</p>
                            <div className="inputgap ">
                                <div className="dropdownwrapper">
                                    <Dropdown2 err={perioderr === "err" ? "err" : ""} func={drpfuncperiod} myplaceholder="Select" fontsize="12" fontfamily="'Poppins', sans-serif" options={optionssession} />
                                </div>
                                <label>{periodlabel}</label>
                            </div>
                        </div>
                    </Col>
                    <Col lg={12} className="text-center">
                        <Purplebutton clickfunc={handleSave} btnname="Save All Data" w="130px" h="35px" mt="20px">

                        </Purplebutton>
                    </Col>
                    <Col lg={12} className="text-center">
                        <div className="redtext">
                        <p>Review all saved subjects and corresponding teacher before setup this data.</p>

                        </div>
                    </Col>
                    </Row>

                </div>
            </div>
        </div>
    </div>
       
    </>
  )
}

export default PreOSetupMonthlyStuTeaComp